import React, {useEffect, useRef} from "react";
import {graphql} from "gatsby";
import parse from "html-react-parser";
import StructuredText from "../custom-structured-text-renderer";
import {gsap} from "gsap";
import {ScrollTrigger} from "gsap/ScrollTrigger";

const TitleContentItems = ({items}) => {
    const itemsRef = useRef()

    useEffect(() => {
        const statsItemsH3 = itemsRef?.current?.querySelectorAll(".title-content-items__item h3");
        const statsItemsP = itemsRef?.current?.querySelectorAll(".title-content-items__item p");

        const animation = () => {
            statsItemsH3.forEach((el, i) => {
                gsap.to(el, {
                    x: 0,
                    opacity: 1,
                    duration: 0.3,
                    ease: 'power1.inOut',
                    delay: i * 0.1
                });
            });
            statsItemsP.forEach((el, i) => {
                gsap.to(el, {
                    x: 0,
                    opacity: 1,
                    duration: 0.4,
                    ease: 'power1.inOut',
                    delay: i * 0.1
                });
            });
        }

        ScrollTrigger.create({
            trigger: '.title-content-items',
            start: "top bottom",
            onEnter: animation,
        });

        return () => {
            ScrollTrigger.getAll().forEach(trigger => trigger.kill());
        };
    }, [items]);

    return (
        <section className='title-content-items' ref={itemsRef}>
            <div className='title-content-items__inner'>
                <div className='title-content-items__items'>
                    {
                        items?.length > 0 && items.map((el, i) => (
                            <div key={i} className='title-content-items__item'>
                                {el.title && <h3>{parse(el.title)}</h3>}
                                {el.richContent && <StructuredText data={el.richContent}/>}
                            </div>
                        ))
                    }
                </div>
            </div>
        </section>
    )
}

export default TitleContentItems

export const query = graphql`
fragment TitleContentItemProps on DatoCmsTitleContentItem {
  ... on DatoCmsTitleContentItem {
    id
    items {
      title
      richContent {
        value
      }
    }
  }
}
`